import React, { Component } from "react";
import { cloneDeep as _cloneDeep, isEqual as _isEqual, isEmpty as _isEmpty, get as _get } from "lodash";
import { FormattedMessage, injectIntl } from "react-intl";
import { NavLink } from "react-router-dom";
import { Form } from "react-bootstrap";
import { connect } from "react-redux";
import Helmet from "react-helmet";

import { showAlertMessage } from "../../components/common/controls";
import { withRouter } from "../../components/hoc/withRouter";
import { isValidEmail } from "../../helpers/utils.js";
import config from "../../helpers/config";

import { doForgotPassword, clearForgotError, clearForgotResponse } from "../../actions/oauth";

class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.defaultCredentials = { email: "" };

    this.state = {
      credentials: _cloneDeep(this.defaultCredentials),
      errors: {},
      disabled: true
    };

    this.legalUrl = config.getFrontendURL(true, true);
  }

  componentDidUpdate(prevProps, prevState) {

    if (!_isEqual(prevState.credentials, this.state.credentials)) { this._handleValidation(); }

    if (!_isEqual(prevProps.success, this.props.success) && !_isEmpty(this.props.success)) {
      const { clearForgotResponse, success } = this.props;

      showAlertMessage(_get(success, "message", "Your request has been submitted successfully."), "success");

      if (typeof clearForgotResponse === "function") { clearForgotResponse(); }
      setTimeout(() => { window.location.href = "/"; }, 5000);
    }

    if (!_isEqual(prevProps.error, this.props.error) && !_isEmpty(this.props.error)) {
      const { clearForgotError, error } = this.props;
      showAlertMessage(_get(error, "message", "Something went wrong while generating forgot password link."));

      if (typeof clearForgotError === "function") { clearForgotError(); }
    }

    if (!_isEqual(prevProps.forgotResponse, this.props.forgotResponse) && this.props.forgotResponse) {
      if (typeof this.props.clearForgotResponse === "function") { this.props.clearForgotResponse(); }
    }

  }

  _handleChange = (e) => {
    e.preventDefault();

    const { name, value } = (e.target || {});

    this.setState((prevState) => ({
      credentials: {
        ...prevState.credentials,
        [name]: value,
      }
    }));
  }

  _doForgotPassword = (event) => {

    event.preventDefault();
    event.stopPropagation();

    const { doForgotPassword } = this.props;
    const { credentials: { email }, errors } = this.state;
    if (_isEmpty(email) || !_isEmpty(errors)) {
      this._handleValidation();

      return;
    }

    try {

      if (typeof doForgotPassword === "function") { doForgotPassword({ email: email, subdomain: this.legalUrl }); }

    } catch (error) {

      showAlertMessage(_get(error, "message", "Something went wrong while generating forgot password link."));
    }

  }

  _handleValidation = () => {
    const { intl } = this.props;
    const { credentials: { email } } = this.state;

    let errors = {};

    if (!isValidEmail(email)) {
      errors["email"] = intl.formatMessage({ id: "error.invalid", defaultMessage: "Invalid {field}" }, {
        field: intl.formatMessage({ id: "email", defaultMessage: "email", }),
      });
    }

    this.setState({
      disabled: !_isEmpty(errors),
      errors
    });
  }

  render() {
    const { intl } = this.props;
    const { errors } = this.state;

    return (
      <>
        <Helmet>
          <title>{intl.formatMessage({ id: "enrich.forgot_password", defaultMessage: "Forgot Password: Enrich B2B" })}</title>
        </Helmet>
        <div className="section-forgot outer-pattern">
          <div className="container container-1120">
            <div className="row">
              <div className="col-lg-12">
                <h1 className="heading-01 fw-medium text-center mb-lg-9 mb-4 text-capitalize">
                  <FormattedMessage id="forgot_password.title" defaultMessage="Forgot Password" />
                </h1>
                <p className="heading-06 text-grey-63 text-center mb-lg-15 mb-8">
                  <FormattedMessage id="forgot_password.e-mail_you_instructions" defaultMessage="We’ll e-mail you instructions on how to reset your password." />
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 mx-auto">

                <Form autoComplete="off" onSubmit={(e) => this._doForgotPassword(e)}>

                  <div className="mb-8">
                    <label className="fw-semibold mb-2">

                      <FormattedMessage id="forgot_password.email" defaultMessage="Email :" />
                    </label>
                    <input type="email" name="email" className="form-control" placeholder="Email" onChange={(e) => this._handleChange(e)} />
                    {(errors.email || "") && (
                      <p className="text-danger mt-1 ps-26 text-capitalize-first">
                        {errors.email}
                      </p>
                    )}
                  </div>

                  <div className="mb-2">
                    <button className="btn btn-lg btn-primary w-100">
                      <FormattedMessage id="forgot_password.reset_password" defaultMessage="Reset Password" />
                    </button>
                  </div>

                  <div className="mb-2">
                    <p className="text-grey-63 fw-bold">
                      <FormattedMessage id="forgot_password.go_back_to" defaultMessage="Go back to" />
                      <NavLink to="/login" className="link-primary text-capitalize">
                        <FormattedMessage id="forgot_password.login" defaultMessage=" login" />
                      </NavLink>
                    </p>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  success: _get(state, "oauth.success", {}),
  error: _get(state, "oauth.error", {}),
  forgotResponse: _get(state, "oauth.forgotResponse", false),
});

const mapDispatchToProps = (dispatch) => ({
  doForgotPassword: (data) => dispatch(doForgotPassword(data)),
  clearForgotError: () => dispatch(clearForgotError()),
  clearForgotResponse: () => dispatch(clearForgotResponse()),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(ForgotPassword)));
